import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers/rootReducer";

export default function Selectors() {
    const cropDimensions: { width: number, height: number } = useSelector(
        (state: RootState) => state.serviceReducer.cropDimensions
    );

    const imageName: string = useSelector(
        (state: RootState) => state.imageReducer.name
    );

    const canvasType: string = useSelector(
        (state: RootState) => state.canvasReducer.format
    );

    const image: string = useSelector(
        (state: RootState) => state.imageReducer.image
    );

    const canvasImage: string = useSelector(
        (state: RootState) => state.canvasReducer.image
    );

    const canvasIsChanged: boolean = useSelector(
        (state: RootState) => state.canvasReducer.isChanged
    );

    const cropIsSaveProportions: boolean = useSelector(
        (state: RootState) => state.canvasReducer.cropIsSaveProportions
    );

    const cropValidation: {
        isValid: boolean;
        input: string;
        type: string;
        description: string;
    } = useSelector((state: RootState) => state.canvasReducer.cropValidation);

    const error: string = useSelector(
        (state: RootState) => state.validatorReducer.error
    );

    const isFlipVertical = useSelector(
        (state: RootState) => state.canvasReducer.isFlipVertical
    );
    const isFlipHorizontal = useSelector(
        (state: RootState) => state.canvasReducer.isFlipHorizontal
    );

    const imageFormat = useSelector(
        (state: RootState) => state.imageReducer.imageFormat
    );

    const imageHeight = useSelector(
        (state: RootState) => state.imageReducer.height
    );

    const imageWidth = useSelector(
        (state: RootState) => state.imageReducer.width
    );

    const cropPosition = useSelector(
        (state: RootState) => state.serviceReducer.cropPosition
    )

    const warningWidth = useSelector((state: RootState) => state.validatorReducer.warningWidth);
    const warningHeight = useSelector((state: RootState) => state.validatorReducer.warningHeight);
    const resizeIsSaveProportion = useSelector((state: RootState) => state.serviceReducer.isPreservationProportions);

    return {
        imageName, canvasType,
        image, canvasImage,
        canvasIsChanged,
        cropIsSaveProportions,
        cropDimensions,
        cropValidation,
        error,
        isFlipVertical,
        isFlipHorizontal,
        imageFormat,
        imageHeight,
        imageWidth,
        cropPosition,
        warningWidth,
        warningHeight,
        resizeIsSaveProportion
    }
}

